import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectSymbolTilesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.SYMBOL_TILE];

export const selectSymbolTileState = (state: State, widgetKey: string) =>
    selectSymbolTilesState(state)[widgetKey];
